var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8263 44.9994C86.8263 21.9875 68.1715 3.33269 45.1596 3.33269C22.1478 3.33269 3.49298 21.9875 3.49298 44.9994C3.49298 68.0112 22.1478 86.666 45.1596 86.666C68.1715 86.666 86.8263 68.0112 86.8263 44.9994Z",
    stroke: "#0073E0",
    strokeWidth: 6.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.493 47.0833L38.9096 57.5L61.8263 32.5",
    stroke: "#0073E0",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.09f05fd21d732e0cf4d7164b2f1e6f92.svg";
export { ForwardRef as ReactComponent };